import React, { Component } from "react"; import config from 'react-global-configuration';
import { Input, Label } from 'reactstrap';
import { Link } from "react-router-dom";
import SimpleReactValidator from 'simple-react-validator';
import { BeatLoader } from 'react-spinners';
import { css } from "@emotion/core";
import Countdown from 'react-countdown';
import axios from "axios";
import invLogo from "../assets/img/innoviti-logo.png";
import { Button } from 'react-bootstrap';
import { Modal } from "react-responsive-modal";
import leftBackImg from "../assets/img/landing_back.png";

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    color: white;
    text-align:center;
`;
const closeIcon = (
    <svg fill="currentColor" viewBox="0 0 20 20" width={28} height={28}>
        <path
            fillRule="evenodd"
            d=""
            clipRule="evenodd"
        ></path>
    </svg>
)
class ForgetPassword extends Component {

    constructor() {
        super();
        this.state = {
            email: '',
            errors: '',
            OTP_SEND: false,
            OTP_VALUE: '',
            user_phone: '',
            new_password: '',
            re_type_password: '',
            loading: false,
            mobile: '',
            countdown_exp: '',
            rcv_otp_type: '',
            subgroup_id: '',
            maskedEmail: '',
            showmodal: false,
            showOTPdiv:false
        };

        this.validator = new SimpleReactValidator();
        this.validator1 = new SimpleReactValidator();
    }
    onChangeEmail(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    changePass(e) {
        this.setState({ [e.target.name]: e.target.value })
    }
    onSubmitPass(e) {
       e.preventDefault();
        if (this.state.email == '') { alert("Please enter Email or phone number"); return false; }

        else if (this.state.maskedEmail != "" && this.state.rcv_otp_type == '')
        {
            alert("Please select OTP verification type"); return false;
        }


        let validate = '';
        if (this.state.OTP_SEND === false) {
            validate = true//this.validator.allValid();

        }
        else {
            validate =  this.validator1.allValid();
        }

        if (validate) {
            this.setState({
                loading: true
            });
            axios.post(config.get('API_URL') + '/users/forget-password', {
                email: this.state.email.trim(),
                OTP_VALUE: this.state.OTP_VALUE,
                user_phone: this.state.user_phone,
                new_changed_pass: this.state.new_password,
                otp_type: this.state.rcv_otp_type
            })
                .then(response => {
                    this.setState({
                        loading: false
                    });
                    if (response.data.responseMessage == 'Invalid Parameters') {
                        this.setState({
                            errors: "Invalid Parameters",
                            loading: false
                        });
                        return false;
                    }
                    if (response.data.responseDetails.requestType == 'GENERATE_OTP') {
                        this.setState({
                            OTP_SEND: true,
                            loading: false,
                            mobile: response.data.responseDetails.mobileNumber,
                            countdown_exp: Date.now()
                        })
                    }
                    else if (response.data.responseDetails.requestType == 'sendEmailWithAttachment') {
                        this.setState({
                            OTP_SEND: true,
                            loading: false,
                            rcv_otp_type: 'email',
                            countdown_exp: Date.now()
                        })
                    }
                    else if (response.data.responseCode == '01') {
                        this.setState({
                            OTP_SEND: true,
                            loading: false,
                            rcv_otp_type: 'email',
                            countdown_exp: Date.now()
                        })
                    }
                    else if (response.data.responseDetails.requestType == 'choose_option') {
                        var maskid = "";
                        var myemailId = response.data.responseDetails.email_id
                        var prefix = myemailId.substring(0, myemailId.lastIndexOf("@"));
                        var postfix = myemailId.substring(myemailId.lastIndexOf("@"));

                        for (var i = 0; i < prefix.length; i++) {
                            if (prefix.length > 4) {
                                if (i == prefix.length - 1 || i == prefix.length - 2 || i == prefix.length - 3) {
                                    maskid = maskid + prefix[i].toString();
                                }
                                else {
                                    maskid = maskid + "*";
                                }
                            }
                            else {
                                if (i == prefix.length - 1) {
                                    maskid = maskid + prefix[i].toString();
                                }
                                else {
                                    maskid = maskid + "*";
                                }
                            }

                        }
                        maskid = maskid + postfix;
                        this.setState({
                            showOTPdiv: true,
                            maskedEmail:maskid,
                            mobile: response.data.responseDetails.phone,
                        })
                    }
                    else if (response.data.responseDetails.requestType == 'Error') {
                        console.log("error");
                        this.setState({
                            errors: response.data.responseDetails.error,
                            loading: false
                        })
                    } else if (response.data.responseDetails.requestType == 'password_changed') {

                        this.setState({
                            loading: false
                        });
                        alert("Your Password has been changed please login.")
                        window.location.href = "/";
                        // console.log(decoded);
                    }

                })
                .catch(err => {
                    console.log(err);
                    console.log(err.error);
                    localStorage.removeItem("usertoken");
                    localStorage.removeItem("userPermission");
                    this.setState({
                        loading: false
                    });
                })

        } else {
            this.validator.showMessages();
            this.validator1.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
            this.setState({
                loading: false
            });
        }
    }
    changePh(e) {
        this.setState({
            user_phone: e.target.value
        })
    }
    onChangeOTPP(e) {
        this.setState({
            OTP_VALUE: e.target.value
        })
    }
    onTypeChanged(e) {
        this.setState({ rcv_otp_type: e.target.alt })
    }
    onCloseModal = () => {
        this.setState({
            showmodal: !this.state.showmodal,
            rcv_otp_type: ''
        });
    };
    onInputModal = () => {
        if(this.state.rcv_otp_type=='')
        {alert("Please select OTP verification type"); return false;}
        this.setState({
            showmodal: !this.state.showmodal,
        });
        this.onSubmitPass();

    };

    render() {
        const Completionist = () => <span className="otpError">OTP has been expired!</span>;
        const renderer = ({ hours, minutes, seconds, completed }) => {
            if (completed) {
                // Render a completed state
                return <Completionist />;
            } else {
                // Render a countdown
                return <span>{hours}:{minutes}:{seconds}</span>;
            }
        };
        this.validator1.purgeFields();
        const confirmPasswordError = this.validator1.message('Confirm Password', this.state.re_type_password, `required|in:${this.state.new_password}`, { messages: { in: 'Passwords need to match!' } });
        const leftBackground = {
            backgroundImage: "url(" + leftBackImg + ")"
        };
        return (
            <div className="authFrom">
                <div className="col-md-6 col-sm-12 no-padd auth-left-background" style={leftBackground}>
                    <div className="welcome-text">
                        <h2>Welcome to Sparcs</h2>
                        <h5>Please reset you password</h5>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12 no-padd auth-right-background">
                    {/*<h2 className="text-center authheading">*/}
                    {/*    <img src={invLogo} alt={invLogo} className="" />*/}
                    {/*</h2>*/}
                    <Modal
                        open={this.state.showmodal}
                        onClose={this.onCloseModal}
                        classNames={{
                            animationIn: 'customEnterAnimation',
                            animationOut: 'customLeaveAnimation',
                        }}
                        animationDuration={500}
                        closeIcon={closeIcon}
                        center
                    >

                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">

                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <span className="red-text"> How would you like to receive the OTP?</span>
                                <div>
                                    <input type="radio" name="otp_type" alt="phone" value={this.state.rcv_otp_type} checked={this.state.rcv_otp_type === 'phone'}
                                        onChange={this.onTypeChanged.bind(this)} />&nbsp;<label>My Phone Number ******{this.state.mobile.substr(-4)}</label>
                                </div>
                                <div>
                                    <input type="radio" name="otp_type" alt="email" value={this.state.rcv_otp_type} checked={this.state.rcv_otp_type === 'email'}
                                        onChange={this.onTypeChanged.bind(this)} />&nbsp;<label>My E-mail Address {this.state.maskedEmail}</label>
                                </div>

                            </div>

                            <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12">

                                <Button
                                    style={{
                                        background: "#36498d",
                                        color: "#fff",
                                        borderRadius: "5px",
                                        width: "80px",
                                        margin: "5px",
                                    }}
                                    onClick={this.onInputModal}
                                    align="center"
                                >
                                    Done
                               </Button>
                                <Button
                                    style={{
                                        background: "#36498d",
                                        color: "#fff",
                                        borderRadius: "5px",
                                        width: "80px",
                                        margin: "5px",
                                    }}
                                    onClick={this.onCloseModal}
                                    align="center"
                                >
                                    Cancel
                                    </Button>
                            </div>

                        </div>

                    </Modal>

                    <div className="login-card ">

                        <form className="" method="POST" onSubmit={this.onSubmitPass.bind(this)} autoComplete="off">
                            <div className="col-md-12 p-0 text-center"> <Label for="Email" className="">Enter your email or mobile number to reset you password</Label></div>
                            <div className="clearfix"></div>
                            {this.state.OTP_SEND === false ?
                                <div className="form-group">
                                    <i className="fa fa-envelope"></i>
                                    <Input placeholder="Enter Email address/Mobile number" name="email" type="text" className="form-control logon-input" value={this.state.email} onChange={this.onChangeEmail.bind(this)} autoComplete="off" />
                                    {this.validator.message('email', this.state.email, 'required|email')}
                                </div> : null}
                            {this.state.OTP_SEND === true ?
                                <React.Fragment>
                                    <div>Verify its you who requested to reset password.</div> <br />
                                    <div className="form-group">
                                        {/*<Label for="Ph" className="">Phone Number</Label>*/}
                                        {/*<i className="fa fa-phone" aria-hidden="true"></i>*/}
                                        {/*<Input placeholder="Enter Phone Number" name="user_phone" type="text" className="form-control logon-input" value={this.state.user_phone} onChange={this.changePh.bind(this)} autoComplete="new-password" />*/}
                                        {/*{this.validator1.message('user_phone', this.state.user_phone, 'required')}*/}
                                    </div>
                                    <div className="form-group">
                                        {/*<Label for="cf" className="">Password: </Label>*/}
                                        <i className="fa fa-lock"></i>
                                        <input type="password" name="new_password"
                                            className="form-control logon-input" value={this.state.new_password}
                                            onChange={this.changePass.bind(this)}
                                            placeholder="Enter New Password" autoComplete="new-password" />
                                        {this.validator1.message('password', this.state.new_password, 'required|min:6|max:20')}
                                    </div>
                                    <div className="form-group">
                                        {/*<Label for="cf" className="">Confirm Your Password: </Label>*/}
                                        <i className="fa fa-lock"></i>
                                        <input type="password" name="re_type_password"
                                            className="form-control logon-input"
                                            value={this.state.re_type_password}
                                            onChange={this.changePass.bind(this)}
                                            placeholder="Re-type Password" autoComplete="new-password" />
                                        {confirmPasswordError}
                                    </div>
                                    <div className="col-md-6 form-group">
                                        <Label for="OTP" className="">Enter OTP: </Label>
                                        <Input name="otp_val" type="text" className="form-control OTP-Text logon-input" value={this.state.OTP_VALUE} onChange={this.onChangeOTPP.bind(this)} autoComplete="off" />
                                        {this.validator1.message('otp', this.state.OTP_VALUE, 'required')}

                                    </div>
                                    <div className="col-md-6 padTop30">
                                        <Countdown
                                            date={this.state.countdown_exp + 300000}
                                            renderer={renderer}
                                        />
                                    </div>
                                    <div className="clearfix"></div>
                                    {this.state.rcv_otp_type=="phone"?
                                     <div className="otpMessage">A SMS verification code send to your register mobile number ******{this.state.mobile.substr(-4)} please verify your account.</div>
                                    : <div className="otpMessage">A verification code send to your register email address {this.state.maskedEmail} please verify your account.</div>
                                    }
                                </React.Fragment>
                                :
                                <>
                                    { this.state.showOTPdiv ===true?
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <span className="red-text"> How would you like to receive the OTP?</span>
                                            <div>
                                                <input type="radio" name="otp_type" alt="phone" value={this.state.rcv_otp_type} checked={this.state.rcv_otp_type === 'phone'}
                                                    onChange={this.onTypeChanged.bind(this)} />&nbsp;<label>My Phone Number ******{this.state.mobile.substr(-4)}</label>
                                            </div>
                                            <div>
                                                <input type="radio" name="otp_type" alt="email" value={this.state.rcv_otp_type} checked={this.state.rcv_otp_type === 'email'}
                                                    onChange={this.onTypeChanged.bind(this)} />&nbsp;<label>My E-mail Address {this.state.maskedEmail}</label>
                                            </div>

                                        </div>:null
                                        }
                             </>
                        }
                            <p className="errmsg">{this.state.errors}</p>
                           
                            <div className="text-center">
                                <button
                                    type="submit" className="btn btn-lg btn-login">Submit
                            </button>&nbsp;&nbsp;&nbsp;&nbsp;
                            <Link to="/">
                                    <button type="submit" className="btn btn-lg btn-login">Back</button>
                                </Link>
                            </div>
                            <BeatLoader
                                css={override}
                                sizeUnit={"px"}
                                size={15}
                                color={'#123abc'}
                                loading={this.state.loading}
                            />
                            <br />
                        </form>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>
        );
    }
}

export default ForgetPassword;